import { PropsWithChildren } from 'react';
import cn from 'classnames';

interface MenuItemProps extends PropsWithChildren {
  icon?: React.ReactNode;
  onClick?: () => void;
  append?: React.ReactNode;
  className?: string;
}
export default function MenuItem(props: MenuItemProps) {
  return (
    <div
      className={cn(
        props.className || '',
        'select-none flex items-center min-w-0 justify-between px-2 mx-3 gap-2 py-2 rounded cursor-pointer hover:bg-[#E5E5E5]/45 transition group'
      )}
      onClick={props.onClick}
    >
      <div className="min-w-0 flex-1 flex items-center gap-2">
        {props.icon}
        <div className="flex-1 text-sm text-[#09090B] truncate">{props.children}</div>
      </div>
      {props.append}
    </div>
  );
}
